const shadows = {
  card: '3px 17px 20px -15px rgba(0, 0, 0, 0.05)',
  menu: 'rgb(0 0 0 / 15%) -4px -4px 25px, rgb(0 0 0 / 17%) 8px 17px 20px',
  raisedCard: '0px 8px 15px -15px rgba(0, 0, 0, 0.5)',
};

export default shadows;
